const $ = jQuery

export default function UspImage() {
  const clickElements = document.querySelectorAll('.mtt-usp-image__list-inner-title')

  if (clickElements.length > 0) {
    for (let i = 0; i < clickElements.length; i++) {
      const clickElement = clickElements[i]
      const slideElement = clickElement.nextElementSibling

      clickElement.addEventListener('click',  () => {
        if (window.innerWidth < 1160) {
          $(slideElement).slideToggle('slow')
          $(clickElement).addClass('mtt-usp-image__list-inner-title--isClicked')
          $(clickElement).toggleClass('mtt-usp-image__list-inner-title-hidden')

          setTimeout(() => {
            $(clickElement).removeClass('mtt-usp-image__list-inner-title--isClicked')
          }, 400)
        }
      })
    }
  }
}